// Sticky Add to Cart Logic 

document.addEventListener('DOMContentLoaded', function() {
  console.log('Sticky ATC: DOMContentLoaded');

  const stickyBar = document.getElementById('sticky-add-to-cart-bar');
  const mainAddToCartForm = document.querySelector('.product-purchase-form');
  const stickyButton = document.getElementById('sticky-add-to-cart-button');
  const footer = document.querySelector('#shopify-section-footer');

  console.log({ stickyBar, mainAddToCartForm, stickyButton, footer });

  if (!stickyBar || !mainAddToCartForm || !stickyButton || !footer) {
    console.warn('Sticky ATC: Essential elements not found. Feature disabled.');
    if (!stickyBar) console.warn('Sticky ATC: stickyBar not found');
    if (!mainAddToCartForm) console.warn('Sticky ATC: mainAddToCartForm (.product-purchase-form) not found');
    if (!stickyButton) console.warn('Sticky ATC: stickyButton not found');
    if (!footer) console.warn('Sticky ATC: footer (#shopify-section-footer) not found');
    return;
  }
  console.log('Sticky ATC: All essential elements found.');

  function getElementTopOffset(element) {
    let offsetTop = 0;
    while(element) {
        offsetTop += element.offsetTop;
        element = element.offsetParent;
    }
    return offsetTop;
  }

  function handleScroll() {
    // console.log('Sticky ATC: handleScroll triggered');
    if (!mainAddToCartForm || !footer) {
        // console.warn('Sticky ATC: mainAddToCartForm or footer not available in handleScroll');
        return;
    }

    const mainButtonContainerTop = getElementTopOffset(mainAddToCartForm);
    const mainButtonContainerHeight = mainAddToCartForm.offsetHeight;
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    const footerTop = getElementTopOffset(footer);
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;


    if (scrollPosition > (mainButtonContainerTop + mainButtonContainerHeight) && scrollPosition < (footerTop - viewportHeight) ) {
      if (stickyBar.style.display !== 'flex') {
        // console.log('Sticky ATC: Showing bar');
        stickyBar.style.display = 'flex';
      }
    } else {
      if (stickyBar.style.display !== 'none') {
        // console.log('Sticky ATC: Hiding bar');
        stickyBar.style.display = 'none';
      }
    }
  }

  stickyButton.addEventListener('click', function(event) {
    event.preventDefault();
    console.log('Sticky ATC: Sticky button clicked');
    // Use mainAddToCartForm for variant checking
    const productHasVariants = mainAddToCartForm.querySelectorAll('.variant-cards-select, .original-selector option').length > 1 || mainAddToCartForm.querySelectorAll('select[name="id"] option').length > 1;
    console.log('Sticky ATC: Product has variants:', productHasVariants);

    if (productHasVariants) {
        const firstVariantSelector = mainAddToCartForm.querySelector('.selector-wrapper, .variant-cards-container');
        if (firstVariantSelector) {
            console.log('Sticky ATC: Scrolling to firstVariantSelector');
            firstVariantSelector.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
            console.log('Sticky ATC: Scrolling to mainAddToCartForm');
            mainAddToCartForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    } else {
      // Directly submit the main product form if no variants or only one default
      console.log('Sticky ATC: Product has no variants or only default. Attempting to submit main form.');
      const submitButton = mainAddToCartForm.querySelector('button[name="add"]');
      if (submitButton) {
        console.log('Sticky ATC: Found submit button in main form, clicking.');
        submitButton.click();
      } else {
        console.warn('Sticky ATC: Submit button not found in main form.');
      }
    }
  });

  window.addEventListener('scroll', handleScroll, { passive: true }); // Added passive for performance
  handleScroll(); // Initial check on load

  console.log('Sticky ATC: Script initialized.');
}); 